(function () {
    'use strict';

    var app = angular.module('inoApp');

    app.filter('month', function () {
        return function (val) {
            return moment().month(val).format('MMMM')
        };
    });
})();